import { ROLES, PERMISSIONS, PERMISSION_LABELS } from "@/lib/permissions";
import { ROLE_LABELS } from "@/lib/api";
import { Check } from "lucide-react";

const PERMISSION_GROUPS = [
  {
    title: "People",
    keys: ["care_seekers.view", "care_seekers.create", "care_seekers.edit", "care_seekers.delete"],
  },
  {
    title: "Intakes & Notes",
    keys: ["intakes.create", "intakes.view", "notes.view", "notes.create", "notes.delete"],
  },
  {
    title: "Referrals & Resources",
    keys: ["referrals.view", "referrals.create", "referrals.edit", "referrals.delete", "resources.view", "resources.create", "resources.edit", "resources.delete"],
  },
  {
    title: "Field work",
    keys: ["outreach.view", "outreach.create", "outreach.delete", "maternal.view", "maternal.create"],
  },
  {
    title: "Tasks",
    keys: ["tasks.view", "tasks.create", "tasks.edit", "tasks.delete"],
  },
  {
    title: "Insights & Admin",
    keys: ["dashboard.view", "reports.view", "exports.download", "users.view", "users.create", "users.edit", "users.delete", "audit.view"],
  },
];

export default function PermissionMatrix() {
  return (
    <div className="bg-white border border-[#E5E5E0] rounded-2xl overflow-hidden" data-testid="permission-matrix">
      <div className="px-6 py-4 border-b border-[#E5E5E0]">
        <h3 className="font-display text-lg font-semibold text-[#0F172A]">Role permissions</h3>
        <p className="text-xs text-[#1E3A8A] mt-1">
          What each role can do across HarborWell Connect. These are enforced both in the interface and on the server.
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F9F8F6] border-b border-[#E5E5E0]">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-[#1E3A8A] uppercase text-[10px] tracking-wider min-w-[220px]">Permission</th>
              {ROLES.map((r) => (
                <th key={r} className="text-center px-3 py-3 font-medium text-[#1E3A8A] uppercase text-[10px] tracking-wider whitespace-nowrap">
                  {ROLE_LABELS[r]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {PERMISSION_GROUPS.map((group) => (
              <>
                <tr key={`g-${group.title}`} className="bg-[#FAF9F5]">
                  <td colSpan={ROLES.length + 1} className="px-4 py-2 hw-eyebrow text-[#1E3A8A]">{group.title}</td>
                </tr>
                {group.keys.map((key) => {
                  const allowed = PERMISSIONS[key] || [];
                  return (
                    <tr key={key} className="border-t border-[#F0EFEB]">
                      <td className="px-4 py-2.5 text-[#334155]">{PERMISSION_LABELS[key] || key}</td>
                      {ROLES.map((r) => (
                        <td key={r} className="text-center px-3 py-2.5">
                          {allowed.includes(r) ? (
                            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#E8ECE7] text-[#166534]">
                              <Check className="w-3.5 h-3.5" strokeWidth={2.5} />
                            </span>
                          ) : (
                            <span className="inline-block w-2 h-px bg-[#E5E5E0]" />
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
